import React from "react";
import { useNavigate } from "react-router-dom";
import PersonIcon from "@mui/icons-material/Person";
import EmailIcon from "@mui/icons-material/Email";
import CarouselCard from "../../../components/Carousel";
import { FleetrifyBgs } from "../../../assets/video";
import { FLEETRIFYROUTEPATH } from "../../../routes/routesPath";
import { useCompanySetup } from "../../../controllers/useCompanySetup";

const CompanySetUp = () => {
  const navigate = useNavigate();
  const { personalOpen, setPersonalOpen, form, handleFormChange, handleNext, sending } = useCompanySetup();

  const slides = [
    { title: "Welcome to Fleetrify", description: "Login to manage logistics and fleet operations" },
    { title: "Real-time Fleet Insights", description: "Get live updates and analytics on every vehicle in your fleet" },
    { title: "Simplify Logistics Management", description: "Automate routing, tracking, and reporting — all in one platform" },
  ];

  return (
    <div className="relative min-h-screen lg:flex">
      {/* video Section */}
      <div className="relative w-full lg:w-[45%] h-screen lg:sticky top-0 flex-shrink-0">
        <video className="absolute inset-0 w-full h-full object-cover" autoPlay muted loop playsInline>
          <source src={FleetrifyBgs} type="video/mp4" />
        </video>
        <div className="absolute inset-0 bg-black opacity-50 z-10"></div>
        <div>
          <CarouselCard slides={slides} />
        </div>
      </div>

      {/*form section */}
      <div className="mt-5 mb-10 w-full lg:w-[55%] lg:static absolute inset-0 z-30 px-4 sm:px-6 lg:px-8 overflow-y-auto">
        <div className="min-h-screen flex items-center justify-center">
          <div className="w-full max-w-[850px] p-6 bg-white rounded-lg shadow lg:shadow-none space-y-6 mx-auto">
            <div className="text-center space-y-2">
              <h2 className="text-[24px] font-bold text-[#143887]">Let's set up your organization</h2>
            </div>
            <h5 className="text-[#000000] text-[16px] tracking-[0.01em] font-bold text-center">
              Are you the head of the organization?
            </h5>

            {/* toggle with yes or no */}
            <div className="flex justify-center items-center gap-4 mt-4">
              <span
                className={`px-6 py-2 rounded-l-md cursor-pointer font-semibold ${personalOpen ? 'bg-[#143887] text-white' : 'bg-gray-200 text-black'}`}
                onClick={() => setPersonalOpen(true)}
              >
                Yes
              </span>
              <span
                className={`px-6 py-2 rounded-r-md cursor-pointer font-semibold ${!personalOpen ? 'bg-[#143887] text-white' : 'bg-gray-200 text-black'}`}
                onClick={() => setPersonalOpen(false)}
              >
                No
              </span>
            </div>

            {/* conditional form for non-head */}
            {!personalOpen && (
              <div className="bg-[#F5F6FA] rounded-lg w-full shadow-md max-w-md mx-auto p-6 space-y-6 mt-6">
                {/* First Name */}
                <div>
                  <label className="block text-[16px] font-bold text-[#000000] mb-1">
                    First Name<span className="text-red-500">*</span>
                  </label>
                  <div className="flex items-center rounded-md px-3 border border-gray-300 focus-within:border-[#143887] focus-within:ring-1 focus-within:ring-[#143887]">
                    <input
                      type="text"
                      placeholder="Enter first name"
                      className="bg-[#F5F6FA] flex-1 py-3 text-[16px] font-normal outline-none text-[#4F4F4F]"
                      value={form.firstname}
                      onChange={(e) => handleFormChange("firstname", e.target.value)}
                    />
                    <PersonIcon className="text-[#333333]" />
                  </div>
                </div>

                {/* Last Name */}
                <div>
                  <label className="block text-[16px] font-bold text-[#000000] mb-1">
                    Last Name<span className="text-red-500">*</span>
                  </label>
                  <div className="flex items-center rounded-md px-3 border border-gray-300 focus-within:border-[#143887] focus-within:ring-1 focus-within:ring-[#143887]">
                    <input
                      type="text"
                      placeholder="Enter last name"
                      className="bg-[#F5F6FA] flex-1 py-3 text-[16px] font-normal outline-none text-[#4F4F4F]"
                      value={form.last_name}
                      onChange={(e) => handleFormChange("last_name", e.target.value)}
                    />
                    <PersonIcon className="text-[#333333]" />
                  </div>
                </div>

                {/* email */}
                <div>
                  <label className="block text-[16px] font-bold text-[#000000] mb-1 mt-2">
                    Organization Email<span className="text-red-500">*</span>
                  </label>
                  <div className="flex items-center rounded-md px-3 border border-gray-300 focus-within:border-[#143887] focus-within:ring-1 focus-within:ring-[#143887]">
                    <input
                      type="email"
                      placeholder="Enter email"
                      className="bg-[#F5F6FA] flex-1 py-3 text-[16px] font-normal outline-none text-[#4F4F4F]"
                      value={form.email}
                      onChange={(e) => handleFormChange("email", e.target.value)}
                    />
                    <EmailIcon className="text-[#333333]" />
                  </div>
                </div>
              </div>
            )}

            {/* cta */}
            <div className="flex flex-col items-center space-y-4 pt-4">
              <button
                onClick={() => handleNext(() => navigate(FLEETRIFYROUTEPATH.COMPANYPROFILE))}
                disabled={sending}
                className="bg-[#143887] text-white py-2 px-20 w-fit rounded-md hover:bg-blue-800"
              >
                {sending ? "Processing..." : "Next"}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CompanySetUp;
